// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DiagnosisModel {
    static getAttributeTypeMap() {
        return DiagnosisModel.attributeTypeMap;
    }
}
DiagnosisModel.discriminator = undefined;
DiagnosisModel.additionalProperties = false;
DiagnosisModel.attributeTypeMap = [
    {
        "name": "diagnosisId",
        "baseName": "diagnosisId",
        "type": "number"
    },
    {
        "name": "diagnosisName",
        "baseName": "diagnosisName",
        "type": "string"
    },
    {
        "name": "diagnosisDescription",
        "baseName": "diagnosisDescription",
        "type": "string"
    },
    {
        "name": "diagnosisCode",
        "baseName": "diagnosisCode",
        "type": "string"
    },
    {
        "name": "diagnosisType",
        "baseName": "diagnosisType",
        "type": "DiagnosisType"
    },
];
//# sourceMappingURL=diagnosisModel.js.map